module.exports = __webpack_public_path__ + "img/GR.b54e0c7b.svg";